import React, { useState } from 'react';

function RouteOptimization() {
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [waypoints, setWaypoints] = useState(['']);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  function handleWaypointChange(idx, value) {
    const newWps = [...waypoints];
    newWps[idx] = value;
    setWaypoints(newWps);
  }

  function addWaypoint() {
    setWaypoints([...waypoints, '']);
  }

  function removeWaypoint(idx) {
    setWaypoints(waypoints.filter((_, i) => i !== idx));
  }

  function handleOptimize(e) {
    e.preventDefault();
    setLoading(true);
    // Dummy AI: shuffle waypoints, calculate mock savings
    setTimeout(() => {
      const shuffled = waypoints.filter(w => w).sort(() => Math.random() - 0.5);
      const optimized = [origin, ...shuffled, destination].filter(Boolean);
      setResult({
        optimized,
        savings: (Math.random() * 20 + 5).toFixed(1),
        time: (Math.random() * 3 + 1).toFixed(1),
      });
      setLoading(false);
    }, 900);
  }

  return (
    <div style={{ padding: 32 }}>
      <h2>AI Route Optimization</h2>
      <p style={{ maxWidth: 600, marginBottom: 32 }}>
        Enter an origin, destination, and optional waypoints. Click <b>Optimize Route</b> to let AI find the most efficient route.<br/>
        <br/>
        <b>Example:</b> Origin: <i>Mumbai</i>, Waypoints: <i>Dubai, Istanbul</i>, Destination: <i>London</i>.<br/>
        <br/>
        The AI will reorder waypoints for the best route and estimate time/cost savings.
      </p>
      <form onSubmit={handleOptimize} style={{ background: '#f4f6fa', padding: 24, borderRadius: 10, maxWidth: 500, marginBottom: 32 }}>
        <div style={{ marginBottom: 16 }}>
          <input
            placeholder="Origin"
            value={origin}
            onChange={e => setOrigin(e.target.value)}
            style={{ width: '100%', padding: 8, marginBottom: 8 }}
            required
          />
          {waypoints.map((wp, idx) => (
            <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <input
                placeholder={`Waypoint ${idx + 1}`}
                value={wp}
                onChange={e => handleWaypointChange(idx, e.target.value)}
                style={{ flex: 1, padding: 8 }}
              />
              <button type="button" onClick={() => removeWaypoint(idx)} style={{ marginLeft: 8, background: '#dc3545', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 10px', cursor: 'pointer' }}>✕</button>
            </div>
          ))}
          <button type="button" onClick={addWaypoint} style={{ background: '#2e8b57', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', marginTop: 4, cursor: 'pointer' }}>+ Add Waypoint</button>
        </div>
        <input
          placeholder="Destination"
          value={destination}
          onChange={e => setDestination(e.target.value)}
          style={{ width: '100%', padding: 8, marginBottom: 16 }}
          required
        />
        <button type="submit" style={{ width: '100%', padding: 10, background: '#1a355e', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16 }} disabled={loading}>
          {loading ? 'Optimizing...' : 'Optimize Route'}
        </button>
      </form>
      {result && (
        <div style={{ background: '#eaf0fa', padding: 24, borderRadius: 10, maxWidth: 500 }}>
          <h3 style={{ marginTop: 0 }}>Optimized Route</h3>
          <ol style={{ marginBottom: 12 }}>
            {result.optimized.map((loc, idx) => <li key={idx}>{loc}</li>)}
          </ol>
          <div style={{ color: '#2e8b57', fontWeight: 500, marginBottom: 4 }}>Estimated Cost Savings: {result.savings}%</div>
          <div style={{ color: '#1a355e', fontWeight: 500 }}>Estimated Time Savings: {result.time} hours</div>
        </div>
      )}
    </div>
  );
}

export default RouteOptimization; 